import { render, staticRenderFns } from "./bottlesTable.vue?vue&type=template&id=65826e56"
import script from "./bottlesTable.vue?vue&type=script&lang=js"
export * from "./bottlesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports